@if (productSpecificCampaign?.textHighlight) {
  <div class="specific-product-campaign-highlight-container">
    <div class="specific-product-campaign-highlight-container_text">
      <span>{{ productSpecificCampaign?.textHighlight }}</span>
    </div>
  </div>
}
